var exports = {
  "PJ": "ChannelLayout.module__channelLayoutContainer___a09tbG",
  "Ei": "ChannelLayout.module__channelNotFoundContainer___a09tbG",
  "Ck": "ChannelLayout.module__channelNotFoundContent___a09tbG",
  "I8": "ChannelLayout.module__channelNotFoundIcon___a09tbG",
  "lV": "ChannelLayout.module__channelNotFoundTitle___a09tbG",
  "f2": "ChannelLayout.module__channelNotFoundDescription___a09tbG",
};

module.exports = exports;
